import ApiURLs from "@/ApiURLs";
import BookedOrder from "@/models/booking/bookedOrder";
import BookingStatus from "@/models/booking/bookingStatus";
import axios from "axios";

export class BookingService {
    getAllProviders() {
        return axios.get(ApiURLs.getAllProviders);
    }

    getCurrentProvider(providerId: string) {
        return axios.get(`${ApiURLs.providersUrl}/${providerId}`);
    }

    getProviderFilters() {
        return axios.get(ApiURLs.getProviderTypeFilters);
    }
    putWaitlistData(childId: string, waitlistTicketId: number, updatedData: any) {
        return axios.put(`${ApiURLs.childrenUrl}/${childId}/waitlist/${waitlistTicketId}`,updatedData);
      }

    getBadgesIsActivated(providerId: string) {
        return axios.get(ApiURLs.getBadgesIsActivated, { params: { providerId } });
    }

    getFamilyAmenitiesById(providerId: string) {
        return axios.get(ApiURLs.getFamilyAmenitiesById, { params: { providerId } });
    }

    getPoliciesAndProceduresById(providerId: string) {
        return axios.get(ApiURLs.getPoliciesAndProceduresById, { params: { providerId } });
    }

    getHoursOfBusinessById(providerId: string) {
        return axios.get(ApiURLs.getHoursOfBusinessById, { params: { providerId } });
    }

    getAvailabilitySettingsByProviderId(providerId: string) {
        return axios.get(ApiURLs.getAvailabilitySettingsByProviderId, { params: { providerId } });
    }

    getHouseholdInfoById(providerId: string) {
        return axios.get(ApiURLs.getHouseholdInfoById, { params: { providerId } });
    }

    saveDaycareOrder(data: any) {
        return axios.post(ApiURLs.saveDaycareOrder, data);
    }

    getDaycareOrders(providerId: string) {
        return axios.get(ApiURLs.getDaycareOrders, { params: { providerId } });
    }

    cancelOrder(data: any) {
        return axios.put(ApiURLs.cancelOrder, data);
    }

    deleteDaycareOrder(orderId: string) {
        return axios.delete(ApiURLs.deleteDaycareOrder, { params: { orderId } });
    }

    bookDaycareOrder(data: {
        bookedDays: any,
        loginPageUrl: string,
        registerPageUrl: string,
        appHomePageUrl: string
        }) {
            let loginPageUrl = data.loginPageUrl;
            let registerPageUrl = data.registerPageUrl;
            let appHomePageUrl = data.appHomePageUrl;

            let params = {
                params: {
                    loginPageUrl: loginPageUrl,
                    registerPageUrl: registerPageUrl,
                    appHomePageUrl: appHomePageUrl
                }
            };

        return axios.put(ApiURLs.bookDaycareOrder, data.bookedDays, params);
    }

    getProviderCurrentOrders(providerId: string) {
        return axios.get(ApiURLs.getProviderCurrentOrders, { params: { providerId } });
    }

    getProviderOrdersHistory() {
        return axios.get(ApiURLs.childcareGetHistory);
    }
    
    setPickUpTimeStamp(orderId: string)
    {
        return axios.put(ApiURLs.setPickUpTimeStamp, null, { params: { orderId } });
    }

    setCheckInTimeStamp(orderId: string)
    {
        return axios.put(ApiURLs.setCheckInTimeStamp, null, { params: { orderId } });
    }

    setNoShowChild(orderId: string)
    {
        return axios.put(ApiURLs.setNoShowChild, null, { params: { orderId } });
    }

    childCareApproveOrder(data: { orderId: string, loginPageUrl: string }) {
        return axios.put(ApiURLs.approveOrder, null, { params: { orderId: data.orderId, loginPageUrl: data.loginPageUrl } });
    }

    childCareApproveAllOrders(data: { body: any, params: { loginPageUrl: string } }) {
        let loginPageUrl = data.params.loginPageUrl;

        return axios.put(ApiURLs.approveAllOrders, data.body, { params: { loginPageUrl } });
    }

    childCareRefuseOrder(data: any) {
        return axios.put(ApiURLs.refuseOrder, data);
    }

    childCareRefuseAllOrders(data: any) {
        return axios.put(ApiURLs.refuseAllOrders, data);
    }

    childCareSetOrderHideCard(orderId: string) {
        return axios.put(ApiURLs.childcareSetOrderHideCard, null, { params: { orderId } });
    } 

    childCareClearOrdersHideCardForProvider() {
        return axios.put(ApiURLs.childcareClearOrdersHideCardForProvider);
    }

    parentSetOrderHideCard(orderId: string) {
        return axios.put(ApiURLs.parentSetOrderHideCard, null, { params: { orderId } });
    } 

    parentClearOrdersHideCardForParent() {
        return axios.put(ApiURLs.parentClearOrdersHideCardForParent);
    }    

    parentRefuseAllOrders(data: any) {
        return axios.put(ApiURLs.parentRefuseAllOrders, data);
    }

    getParentOrdersHistory() {
        return axios.get(ApiURLs.getParentOrdersHistory);
    }

    getUserProfileById(providerId: string) {
        return axios.get(ApiURLs.getUserProfileById, { params: { providerId } });
    }

    saveFavoritesLiked(data: any) {
        return axios.post(ApiURLs.saveFavoritesLiked, data);
    }

    getHolidaysForRestNextYear(providerId: string, dateNow: Date) {        
        return axios.get(ApiURLs.getHolidaysForRestNextYear, { params: { providerId, dateNow } });
    }

    createParentReoccurringOrders(bookedOrder: BookedOrder) {
        return axios.post(ApiURLs.createParentReoccurringOrders, bookedOrder);
    }

    createChildcareReoccurringOrders(bookedOrder: BookedOrder) {
        return axios.post(ApiURLs.createChildcareReoccurringOrders, bookedOrder);
    }

    getProviderBackgroundGallery(userId: string) {
        return axios.get(ApiURLs.getProviderBackgroundGallery, { params: { userId } });
    }    

    saveProviderBackgroundGallery(data: any) {
        return axios.post(ApiURLs.saveProviderBackgroundGallery, data);
    }

    getBookingStatus() {
        return axios.get(ApiURLs.getBookingStatus);
    }

    updateBookingStatus(bookingStatus: BookingStatus) {
        return axios.put(ApiURLs.updateBookingStatus, bookingStatus);
    }
}

export default new BookingService();